import {
    Box, Button, Checkbox,
    Container, FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel, MenuItem,
    Radio,
    RadioGroup,
    Select, Stack, TextField, Typography, Alert
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { BsFiles, BsSearch, BsUpload } from "react-icons/bs";
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../api/axiosClient';
import Page from 'src/components/Page';
import NewWindow from 'src/utils/newwindow';
import PageHeader from '../../components/page-header';
import MemberInfo from './MemberInfo';

const commonFormStyle = { width: '100%', marginTop: 10 };

const Member = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [files, setFiles] = useState([])
    const [member, setMember] = useState({});
    const [company, setCompany] = useState({});
    const [companyQuery, setCompanyQuery] = useState({});
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        getValues,
        setValue,
        trigger
    } = useForm()
    const open = useDaumPostcodePopup();
    const inputFile = useRef(null);
    const postBtnRef = useRef(null);
    const [searchCompanyShow, setSearchCompanyShow] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/members/${params.username}`)
            const payload = response.data.data;

            if(payload.user.com_id === null) {
                toast.error('회사정보가 부재합니다. 관련 정보를 업데이트가 요구됩니다.', {
                    position: "top-center"
                });
            }

            setMember({
                username: payload.user.username || params.username,
                name: payload.user.name || "",
                phone: payload.user.phone || "",
                email: payload.user.email || "",
                research_field: payload.user.research_field || "",
            });
            setCompany(payload.company || {});

            const defaultValues = {
                username: payload.user.username || params.username,
                name: payload.user.name || "",
                phone: payload.user.phone || "",
                email: payload.user.email || "",
                com_type: payload.company?.com_type || "",
                com_name: payload.company?.com_name || "",
                com_code: payload.company?.com_code || "",
                com_ceo: payload.company?.com_ceo || "",
                com_sector: payload.company?.com_sector || "",
                com_field: payload.company?.com_field || "",
                bizlicense: payload.company?.bizlicense || "",
                com_zip: payload.company?.com_zip || "",
                com_addr1: payload.company?.com_addr1 || "",
                com_addr2: payload.company?.com_addr2 || "",
                tax_tp: payload.companyTax?.tax_tp || "",
                tax_charge: payload.companyTax?.tax_charge || "",
                tax_phone_landline: payload.companyTax?.tax_phone_landline || "",
                tax_email: payload.companyTax?.tax_email || "",
                tax_phone_mobile: payload.companyTax?.tax_phone_mobile || "",
                research_field: payload.user.research_field || "",
                order_email: payload.user.order_email || "",
                job_title: payload.user.job_title || "",
                landline: payload.user.landline || "",
                order_name: payload.user.order_name || "",
                order_phone: payload.user.order_phone || "",
                prof_name: payload.user.prof_name || "",
                prof_loc: payload.user.prof_loc || "",
                dept_name: payload.user.dept_name || "",
                dept_loc: payload.user.dept_loc || ""
            }
            reset(defaultValues)
        }

        params.username && fetchData();
    }, [reset, params.username]);


    const onSubmitUser = async (data, e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('username', data.username);
        formData.append('name', data.name);
        formData.append('phone', data.phone);
        formData.append('email', data.email);
        formData.append('research_field', data.research_field);
        formData.append('order_email', data.order_email);
        formData.append('job_title', data.job_title);
        formData.append('landline', data.landline);
        formData.append('order_name', data.order_name);
        formData.append('order_phone', data.order_phone);
        formData.append('prof_name', data.prof_name);
        formData.append('prof_loc', data.prof_loc);
        formData.append('dept_name', data.dept_name);
        formData.append('dept_loc', data.dept_loc);
        
        await apiService.putFormData('/users/update/user', formData)
        .then(response => {
            toast.success('변경되었습니다.', {
                position: "top-right"
            });
        })
        .catch(error => {
            console.error(error)
        });
    }

    const onSubmitCompany = async (data, e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('username', params.username);
        formData.append('com_id', company.com_id || "");
        formData.append('com_type', data.com_type);
        formData.append('com_name', data.com_name);
        formData.append('com_code', data.com_code);
        formData.append('com_ceo', data.com_ceo);
        formData.append('com_sector', data.com_sector);
        formData.append('com_field', data.com_field);
        formData.append('bizlicense', data.bizlicense);
        formData.append('com_zip', data.com_zip);
        formData.append('com_addr1', data.com_addr1);
        formData.append('com_addr2', data.com_addr2);

        if(files) {
            formData.append('file', files);
        }

        await apiService.postFormData('/users/company', formData)
        .then(response => {
            toast.success('변경되었습니다.', {
                position: "top-right"
            });
        })
        .catch(error => {
            console.error(error)
        });
    }

    const onSubmitTax = async (data, e) => {
        e.preventDefault();

        if(!company.com_code) {
            toast.error('사업자등록번호를 입력해주세요.', {
                position: "top-right"
            });
            return;
        }

        const formData = new FormData();
        formData.append('username', params.username);
        formData.append('com_code', company.com_code);        
        formData.append('tax_charge', data.tax_charge);            
        formData.append('tax_phone_mobile', data.tax_phone_mobile);
        formData.append('tax_phone_landline', data.tax_phone_landline);
        formData.append('tax_email', data.tax_email);
        formData.append('tax_tp', data.tax_tp);

        await apiService.postFormData('/users/company_tax', formData)
        .then(response => {
            toast.success('변경되었습니다.', {
                position: "top-right"
            });
        })
        .catch(error => {
            console.error(error)
        });
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setValue('bizlicense', file.name);
            setFiles(file); // Store the file in state for submission

            trigger('bizlicense');
        }
    };

    const handleFileSearch = (e) => {
        e.preventDefault();
        document.getElementById('file-input').click();
    }

    const handleFileOpen = (e) => {
        e.preventDefault();
        company.com_bizfile && window.open(`${company.com_bizfile}`, '_blank');
    }

    const payOptionChange = async (e) => {
        if(e.target.checked) {
            setValue('tax_charge', getValues('order_name'));
            setValue('tax_phone_landline', getValues('landline'));
            setValue('tax_email', getValues('order_email'));
            setValue('tax_phone_mobile', getValues('order_phone'));

            await trigger(['tax_charge', 'tax_phone_landline', 'tax_email', 'tax_phone_mobile']);
        } else {
            setValue('tax_charge', "");
            setValue('tax_phone_landline', "");
            setValue('tax_email', "");
            setValue('tax_phone_mobile', "");

            await trigger(['tax_charge', 'tax_phone_landline', 'tax_email', 'tax_phone_mobile']);
        }
    }

    const handleClose = () => {
        postBtnRef.current.disabled = false;
    }

    const handleComplete = async (data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
        }

        setValue('com_zip', data.zonecode);
        setValue('com_addr1', fullAddress);

        await trigger(['com_zip', 'com_addr1']);
    };

    const handleClick = () => {
        postBtnRef.current.disabled = true;
        open({ onComplete: handleComplete, onClose: handleClose });
    };

    const searchCompanyName = async () => {   
        const value = getValues('com_name');        
        setCompanyQuery({ field: 'com_name', q: value || ""  });
        setSearchCompanyShow(true);
    }
    
    const searchCompanyCode = async () => {
        const value = getValues('com_code');
        setCompanyQuery({ field: 'com_code', q: value || "" });
        setSearchCompanyShow(true);
    }

    window.companyReceiver = async (company) => {
        setCompany(company);

        setValue('com_type', company.com_type);
        setValue('com_name', company.com_name);
        setValue('com_code', company.com_code);
        setValue('com_ceo', company.com_ceo);
        setValue('com_sector', company.com_sector);
        setValue('com_field', company.com_field);
        setValue('com_zip', company.com_zip);
        setValue('com_addr1', company.com_addr1);
        setValue('com_addr2', company.com_addr2);

        await trigger(['com_type', 'com_name', 'com_code', 'com_ceo', 'com_sector', 'com_field', 'com_zip', 'com_addr1', 'com_addr2']);
    }

    const handleSearchClose = () => {
        setSearchCompanyShow(false);
    }

    const CompanySearchWindow = () => {
        return (
            searchCompanyShow ? (
            <NewWindow 
                url={`/find/company?field=${companyQuery.field}&q=${companyQuery.q}`} 
                title={"회사 검색"} 
                features = {{ left: '100px', top: '100px', width: '800px', height: '900px'}}
                onUnload={handleSearchClose} /> ) 
            : ""
        )
    }    

    return (
        <Page title="Member">
            <Container>
                <PageHeader
                    title={
                        <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                            <Typography variant='h5' color='#666CFF'>
                                회원 정보
                            </Typography>
                        </Stack>
                    }
                    subtitle={
                        <Typography variant='body2'>
                            모든항목의 회원 정보를 입력해주세요.
                        </Typography>
                    }
                />
                
                <Grid container>
                    <Box component="form" id="userform" onSubmit={handleSubmit(onSubmitUser)} sx={commonFormStyle}>
                        <Typography variant="h5" sx={{ marginBottom: 4 }}>
                            기본 정보
                        </Typography>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='username'
                                        control={control}
                                        rules={{ required: true }}                                            
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField                                                    
                                                label='사용자 ID'
                                                id='username'
                                                value={value}
                                                onChange={onChange}
                                                placeholder='사용자 ID를 입력해주세요'
                                                error={Boolean(errors.username)}
                                                disabled
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>                    

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="name"
                                        control={control}
                                        rules={{ required: "이름을 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="이름"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="이름"
                                                error={Boolean(errors.name)} // Show error if validation fails
                                                helpertext={errors.name?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="phone"
                                        control={control}
                                        rules={{ required: "연락처를 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="연락처"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="연락처"
                                                error={Boolean(errors.phone)} // Show error if validation fails
                                                helpertext={errors.phone?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="email"
                                        control={control}                                            
                                        rules={{
                                            required: "이메일을 입력해주세요.",
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Email validation regex
                                                message: "유효한 이메일 주소를 입력해주세요.",
                                            },
                                        }} // Add validation rules
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="이메일"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="이메일"
                                                error={Boolean(errors.email)} // Show error if validation fails
                                                helpertext={errors.email?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>                                                                                    
                        </Grid>

                        <Typography variant="h5" sx={{ marginTop: 4, marginBottom: 4 }}>
                            주문자 정보
                        </Typography>
                        <Grid container spacing={4}>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel id='classify-research'>관심분야</InputLabel>
                                <Controller
                                    name='research_field'
                                    control={control}
                                    rules={{ required: "관심분야를 선택해주세요." }} // Add validation rules
                                    defaultValue=""                                            
                                    render={({ field: { value, onChange } }) => (
                                        <Select
                                            label='관심분야'
                                            value={value}
                                            onChange={onChange}                                                
                                            labelId='classify-research'
                                            error={Boolean(errors.research_field)}
                                            helpertext={errors.research_field?.message}
                                        >
                                            <MenuItem value="분석">분석 (제약,크로마토그래피,용매)</MenuItem>
                                            <MenuItem value="화학">화학 (유기합성,무기합성,빌딩블럭)</MenuItem>
                                            <MenuItem value="바이오">바이오 (항체,세포,단백질,유전자)</MenuItem>
                                            <MenuItem value="소재">소재 (금속,합금,세라믹,폴리머)</MenuItem>
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth required>
                                <Controller
                                    name="order_email"
                                    control={control}
                                    rules={{
                                        required: "이메일을 입력해주세요.",
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Email validation regex
                                            message: "유효한 이메일 주소를 입력해주세요.",
                                        },
                                    }} // Add validation rules
                                    defaultValue="" // Default value for the field
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            label="이메일"
                                            type="email"
                                            value={value}
                                            onChange={onChange}
                                            placeholder="이메일"
                                            error={Boolean(errors.order_email)} // Show error if validation fails
                                            helpertext={errors.order_email?.message} // Display validation error message
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth required>
                                <Controller
                                    name="job_title"
                                    control={control}
                                    rules={{ required: "직급을 입력해주세요." }} // Add validation rules
                                    defaultValue="" // Default value for the field
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            label="직급"
                                            value={value}
                                            onChange={onChange}
                                            placeholder="직급"
                                            error={Boolean(errors.job_title)} // Show error if validation fails
                                            helpertext={errors.job_title?.message} // Display validation error message
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth required>
                                <Controller
                                    name="landline"
                                    control={control}
                                    rules={{
                                        required: "유선전화를 입력해주세요.", // Add validation rules
                                        pattern: {
                                            value: /^[0-9-]+$/, // Allow only numbers and dashes
                                            message: "유효한 유선전화 번호를 입력해주세요.",
                                        },
                                    }}
                                    defaultValue="" // Default value for the field
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            label="유선전화"
                                            type="tel"
                                            value={value}
                                            onChange={onChange}
                                            placeholder="유선전화"
                                            inputProps={{ maxLength: 20 }}
                                            error={Boolean(errors.landline)} // Show error if validation fails
                                            helpertext={errors.landline?.message} // Display validation error message
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>                        

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth required>
                                <Controller
                                    name="order_name"
                                    control={control}
                                    rules={{ required: "성함을 입력해주세요." }} // Add validation rules
                                    defaultValue="" // Default value for the field
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            label="성함"
                                            value={value}
                                            onChange={onChange}
                                            placeholder="성함"
                                            error={Boolean(errors.order_name)} // Show error if validation fails
                                            helpertext={errors.order_name?.message} // Display validation error message
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth required>
                                <Controller
                                    name="order_phone"
                                    control={control}
                                    rules={{
                                        required: "연락처를 입력해주세요.", // Add validation rules
                                        pattern: {
                                            value: /^[0-9-]+$/, // Allow only numbers and dashes
                                            message: "유효한 연락처를 입력해주세요.",
                                        },
                                    }}
                                    defaultValue="" // Default value for the field
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            label="연락처"
                                            type="tel"
                                            value={value}
                                            onChange={onChange}
                                            placeholder="연락처"
                                            inputProps={{ maxLength: 30 }}
                                            error={Boolean(errors.order_phone)} // Show error if validation fails
                                            helpertext={errors.order_phone?.message} // Display validation error message
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        {company.com_type === "학교" && (
                            <>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="prof_name"
                                            control={control}
                                            defaultValue="" // Default value for the field
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    label="담당교수명"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="담당교수명"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="prof_loc"
                                            control={control}
                                            defaultValue="" // Default value for the field
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    label="교수님호실"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="교수님호실"
                                                    inputProps={{ maxLength: 20 }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(company.com_type === "학교" || company.com_type === "연구소" || company.com_type === "제조업") && (
                            <>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="dept_name"
                                            control={control}
                                            defaultValue="" // Default value for the field
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    label={company.com_type === "학교" ? "학과명" : "부서명"}
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder={company.com_type === "학교" ? "학과명" : "부서명"}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="dept_loc"
                                            control={control}
                                            defaultValue="" // Default value for the field
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    label={company.com_type === "학교" ? "학과호실" : "부서호실"}
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder={company.com_type === "학교" ? "학과호실" : "부서호실"}
                                                    inputProps={{ maxLength: 30 }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}
                        </Grid>

                        <Stack direction="row" py={4}>
                            <Button type="submit" form="userform" variant='contained'>
                                회원 정보 수정
                            </Button>
                        </Stack>
                    </Box>
                    
                    <Box component="form" id="companyform" onSubmit={handleSubmit(onSubmitCompany)} sx={commonFormStyle}>
                        <Box sx={{marginBottom: 6}}>
                            <Typography variant="h5" sx={{ marginBottom: 2 }}>
                                사업자 등록정보
                            </Typography>
                            <Alert severity='error'>
                                업체를 검색 선택해서 적용 수정을 하시면, <strong>결재정보 수정</strong> 버튼을 눌러 변경해줘야 합니다.
                            </Alert>
                        </Box>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>                                    
                                <FormControl fullWidth>
                                    <InputLabel id='classify-label'>업체분류</InputLabel>
                                    <Controller
                                        name='com_type'
                                        control={control}
                                        rules={{ required: "업체분류를 선택해주세요." }} // Add validation rules
                                        defaultValue=""                                            
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='업체분류'
                                                value={value}
                                                // onChange={onChange}
                                                onChange={(e) => {
                                                    setValue('com_type', e.target.value);
                                                    setCompany({ ...company, com_type: e.target.value });
                                                }}
                                                labelId='classify-label'
                                                error={Boolean(errors.com_type)}
                                                helpertext={errors.com_type?.message}
                                            >
                                                <MenuItem value="">선택하세요.</MenuItem>
                                                <MenuItem value="국가연구소">국가연구소</MenuItem>
                                                <MenuItem value="제조업">제조업</MenuItem>
                                                <MenuItem value="학교">학교</MenuItem>
                                                <MenuItem value="도소매">도소매</MenuItem>
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="com_name"
                                        control={control}
                                        rules={{ required: "업체명을 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="업체명"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="업체명"
                                                error={Boolean(errors.com_name)} // Show error if validation fails
                                                helpertext={errors.com_name?.message} // Display validation error message
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton edge="end" onClick={searchCompanyName} sx={{ padding: 2, marginRight: 1 }}>
                                                                <BsSearch />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="com_code"
                                        control={control}
                                        rules={{ required: "사업자등록번호를 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="사업자등록번호"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="사업자등록번호"
                                                error={Boolean(errors.com_code)} // Show error if validation fails
                                                helpertext={errors.com_code?.message} // Display validation error message
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton edge="end" onClick={searchCompanyCode} sx={{ padding: 2, marginRight: 1 }}>
                                                                <BsSearch />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="com_ceo"
                                        control={control}
                                        rules={{ required: "대표자명을 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="대표자명"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="대표자명"
                                                error={Boolean(errors.com_ceo)} // Show error if validation fails
                                                helpertext={errors.com_ceo?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="com_sector"
                                        control={control}
                                        rules={{ required: "업태를 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="업태"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="업태"
                                                error={Boolean(errors.com_sector)} // Show error if validation fails
                                                helpertext={errors.com_sector?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="com_field"
                                        control={control}
                                        rules={{ required: "종목를 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="종목"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="종목"
                                                error={Boolean(errors.com_field)} // Show error if validation fails
                                                helpertext={errors.com_field?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Input type="file" id="file-input" name="bizlicense1" style={{ display: 'none' }} onChange={handleFileChange} inputRef={inputFile} />

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="bizlicense"
                                        control={control}
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="사업자등록증"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="사업자등록증"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {
                                                                company.com_bizfile && 
                                                                <IconButton color="primary" edge="end" onClick={handleFileOpen} sx={{padding: 2, marginRight: 2}}>
                                                                    <BsFiles />
                                                                </IconButton>
                                                            }
                                                            <IconButton
                                                                edge="end"
                                                                ref={postBtnRef}
                                                                onClick={handleFileSearch}
                                                                sx={{ padding: 2, marginRight: 1 }}
                                                            >
                                                                <BsUpload />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="com_zip"
                                        control={control}
                                        rules={{ required: "사업자등록소재지를 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="사업자등록소재지"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="사업자등록소재지"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                edge="end"
                                                                ref={postBtnRef}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleClick(); // Open the address search popup
                                                                }}
                                                                sx={{ padding: 2, marginRight: 1 }}
                                                            >
                                                                <BsSearch />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                error={Boolean(errors.com_zip)} // Show error if validation fails
                                                helpertext={errors.com_zip?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="com_addr1"
                                        control={control}
                                        rules={{ required: "주요주소를 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="주요주소"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="주요주소"
                                                error={Boolean(errors.com_addr1)} // Show error if validation fails
                                                helpertext={errors.com_addr1?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="com_addr2"
                                        control={control}
                                        rules={{ required: "세부주소를 입력해주세요." }} // Add validation rules
                                        defaultValue="" // Default value for the field
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="세부주소"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="세부주소"
                                                error={Boolean(errors.com_addr2)} // Show error if validation fails
                                                helpertext={errors.com_addr2?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>                            
                        </Grid>

                        <Stack direction="row" py={4}>
                            <Button type="submit" form="companyform" variant='contained'>
                                사업자 정보 수정
                            </Button>
                        </Stack>
                    </Box>                    

                    <Box component="form" id="taxform" onSubmit={handleSubmit(onSubmitTax)} sx={commonFormStyle}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 2,
                            }}
                        >
                            <Typography variant="h5">결제정보</Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        id="sameinfo"
                                        name="sameinfo"
                                        onChange={payOptionChange}
                                    />
                                    }
                                    label="주문자 정보와 동일지정"
                                />
                                <Controller
                                    name="tax_tp"
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <RadioGroup 
                                            row 
                                            value={value || "10"} // Ensure value is not null
                                            onChange={onChange}
                                        >
                                            <FormControlLabel value="10" control={<Radio />} label="발행" />
                                            <FormControlLabel value="20" control={<Radio />} label="카드결제" />
                                        </RadioGroup>
                                    )}
                                />
                            </Box>
                        </Box>

                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="tax_charge"
                                        control={control}
                                        defaultValue="" // Default value for the field
                                        rules={{ required: "성함을 입력해주세요." }} // Add validation rules
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="성함"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="성함"
                                                error={Boolean(errors.tax_charge)} // Show error if validation fails
                                                helpertext={errors.tax_charge?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="tax_phone_landline"
                                        control={control}
                                        defaultValue="" // Default value for the field
                                        rules={{
                                            required: "유선전화를 입력해주세요.", // Add validation rules
                                            pattern: {
                                                value: /^[0-9-]+$/, // Allow only numbers and dashes
                                                message: "유효한 유선전화 번호를 입력해주세요.",
                                            },
                                        }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="유선전화"
                                                type="tel"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="유선전화"
                                                inputProps={{ maxLength: 30 }}
                                                error={Boolean(errors.tax_phone_landline)} // Show error if validation fails
                                                helpertext={errors.tax_phone_landline?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="tax_email"
                                        control={control}
                                        defaultValue="" // Default value for the field
                                        rules={{
                                            required: "이메일을 입력해주세요.", // Add validation rules
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Email validation regex
                                                message: "유효한 이메일 주소를 입력해주세요.",
                                            },
                                        }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="이메일"
                                                type="email"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="이메일"
                                                error={Boolean(errors.tax_email)} // Show error if validation fails
                                                helpertext={errors.tax_email?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <Controller
                                        name="tax_phone_mobile"
                                        control={control}
                                        defaultValue="" // Default value for the field
                                        rules={{
                                            required: "휴대전화를 입력해주세요.", // Add validation rules
                                            pattern: {
                                                value: /^[0-9-]+$/, // Allow only numbers and dashes
                                                message: "유효한 휴대전화 번호를 입력해주세요.",
                                            },
                                        }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label="휴대전화"
                                                type="tel"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="휴대전화"
                                                inputProps={{ maxLength: 30 }}
                                                error={Boolean(errors.tax_phone_mobile)} // Show error if validation fails
                                                helpertext={errors.tax_phone_mobile?.message} // Display validation error message
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Stack direction="row" py={4}>
                            <Button type="submit" form="taxform" variant='contained'>
                                결제 정보 수정
                            </Button>
                        </Stack>
                    </Box>
                    
                </Grid>                

                <Stack direction="row" spacing={2} sx={{ py: 16, justifyContent: 'center' }}>
                    <Button variant='outlined' onClick={() => {navigate(-1)}}>
                        취소
                    </Button>
                </Stack>
                {
                    params.username && <MemberInfo username={member.username}/>
                }
            </Container>            
            <CompanySearchWindow />            
        </Page>
    )
}

export default Member